// Чистые правила покупки пакета (без React и сети) — покрыты
// purchaseLogic.test.ts. Хук `usePackagePurchase` только исполняет их решения.
import { isSubscriptionPackage } from "@/shared/lib/subscriptionView";
/**
 * Провайдер оплаты для пакета: ЮKassa приоритетнее, затем Lava. `null` —
 * оплата пакетом невозможна (ни один провайдер не включён).
 *
 * Подписка — только ЮKassa: автосписания умеет лишь она, на другой провайдер
 * бэк ответит `subscription_provider_unsupported`.
 */
export function resolvePackageProvider(pkg) {
    if (pkg.is_yookassa_available)
        return "yookassa";
    if (isSubscriptionPackage(pkg))
        return null;
    if (pkg.is_lava_available)
        return "lava";
    return null;
}
/** Пакет можно оплатить (есть хотя бы один включённый провайдер). */
export function canPayPackage(pkg) {
    return resolvePackageProvider(pkg) !== null;
}
/**
 * Запрос на создание платежа.
 *
 * Разовый пакет — только `package_id`, `provider` и (если есть) почта: ровно
 * как было до подписок.
 *
 * Подписка добавляет:
 *  • `autorenewal_consent: true` — бэк без него откажет;
 *  • `return_url` на сайт — ТОЛЬКО в вебе. Платёж пользователя с прошлой
 *    подпиской из бота уходит в TG-шоп ЮKassa, который по умолчанию вернул бы в
 *    бота. В миниапе TG/MAX адрес НЕ шлём: касса открыта во внешнем браузере
 *    без сессии, и `/payment/success` там показал бы «не удалось подтвердить
 *    оплату» — пусть возвращает в бота, как у разовых покупок.
 */
export function buildPaymentCreateRequest({ pkg, provider, billingEmail, consentGiven, isWebEnv, returnUrl, }) {
    const request = { package_id: pkg.id, provider };
    if (billingEmail)
        request.billing_email = billingEmail;
    if (isSubscriptionPackage(pkg)) {
        if (consentGiven)
            request.autorenewal_consent = true;
        if (isWebEnv && returnUrl)
            request.return_url = returnUrl;
    }
    return request;
}
/**
 * Первый шаг оформления подписки: гостю и неавторизованному — вход (подписка
 * привязана к аккаунту, бэк гостю откажет `subscription_auth_required`),
 * аккаунту — модалка согласия на автосписания.
 */
export function getSubscriptionPurchaseStep(accountId) {
    return accountId === null ? "auth" : "consent";
}
/** Платёж за подписку можно создавать, только когда чекбокс согласия отмечен. */
export function canSubmitSubscriptionConsent(agreed) {
    return agreed === true;
}
/**
 * Что делать после входа, если до него гость нажал «Оформить»:
 *  • `skip` — вход не состоялся: молча ничего не делаем;
 *  • `already_subscribed` — у вошедшего аккаунта подписка уже есть: вместо
 *    модалки согласия говорим об этом;
 *  • `consent` — показываем согласие по тому же пакету.
 * Решать можно, только когда ответ про подписку пришёл ИМЕННО по вошедшему
 * аккаунту — иначе `wait` (сначала дождаться загрузки).
 */
export function decideSubscriptionResume({ accountId, subscriptionOwnerId, subscriptionResolved, hasSubscription, }) {
    if (accountId === null)
        return "skip";
    if (subscriptionOwnerId !== accountId || !subscriptionResolved)
        return "wait";
    return hasSubscription ? "already_subscribed" : "consent";
}
